import { concat } from '../bytes/encoding';

export async function sha256(...parts: Uint8Array[]): Promise<Uint8Array> {
  const data = parts.length === 1 ? parts[0]! : concat(...parts);
  return new Uint8Array(await crypto.subtle.digest('SHA-256', data as BufferSource));
}
